import React from 'react';
import {Footer} from '../../_common/components/Footer/Footer';
import {useAiReportsContext} from '../context/AiReportsContext';

export const AiReportsFooter = () => {
  const {totalCount} = useAiReportsContext();

  return <Footer count={totalCount ?? 0}/>;
};
